/**
 * Validation and input constants copied from ame.site AuthRegistration.
 */

export const AUTH_OTP_LENGTH = 4
export const AUTH_RESEND_MS = 60_000

export const AUTH_NAME_MAX_LENGTH = 80
export const AUTH_NAME_MIN_LENGTH = 1

/** UA only in v1 */
export const AUTH_DEFAULT_COUNTRY = 'UA'
export const AUTH_UA_CALLING_CODE = '380'

export const AUTH_ERROR_CODES = {
  INVALID_PHONE: 'invalid_phone',
  INVALID_CODE: 'invalid_code',
  EXPIRED_CODE: 'expired_code',
  CODE_USED: 'code_used',
  RESEND_COOLDOWN: 'resend_cooldown',
  RATE_LIMIT: 'rate_limit',
  PROVIDER_UNAVAILABLE: 'provider_unavailable',
  INVALID_NAME: 'invalid_name',
  INVALID_LAST_NAME: 'invalid_last_name',
  INVALID_EMAIL: 'invalid_email',
  ACCOUNT_DISABLED: 'account_disabled',
  TOKEN_USED: 'token_used',
  NOT_CONFIGURED: 'not_configured',
  NETWORK: 'network',
  UNKNOWN: 'unknown',
}

export const AUTH_ERROR_MESSAGES = {
  [AUTH_ERROR_CODES.INVALID_PHONE]: 'Введіть коректний номер телефону',
  [AUTH_ERROR_CODES.INVALID_CODE]: 'Невірний код',
  [AUTH_ERROR_CODES.EXPIRED_CODE]: 'Цей код вже недійсний. Надішліть новий',
  [AUTH_ERROR_CODES.CODE_USED]: 'Код уже використано. Надішліть новий',
  [AUTH_ERROR_CODES.RESEND_COOLDOWN]: 'Зачекайте перед повторною відправкою коду',
  [AUTH_ERROR_CODES.RATE_LIMIT]: 'Забагато спроб. Спробуйте пізніше',
  [AUTH_ERROR_CODES.PROVIDER_UNAVAILABLE]: 'SMS тимчасово недоступні. Спробуйте ще раз',
  [AUTH_ERROR_CODES.INVALID_NAME]: 'Вкажіть ім’я',
  [AUTH_ERROR_CODES.INVALID_LAST_NAME]: 'Вкажіть прізвище',
  [AUTH_ERROR_CODES.INVALID_EMAIL]: 'Введіть коректний email',
  [AUTH_ERROR_CODES.ACCOUNT_DISABLED]: 'Обліковий запис вимкнено',
  [AUTH_ERROR_CODES.TOKEN_USED]: 'Підтвердження вже використано. Пройдіть вхід знову',
  [AUTH_ERROR_CODES.NOT_CONFIGURED]: 'Завершення реєстрації буде доступне наступним кроком',
  [AUTH_ERROR_CODES.NETWORK]: 'Немає зв’язку. Спробуйте ще раз',
  [AUTH_ERROR_CODES.UNKNOWN]: 'Щось пішло не так. Спробуйте ще раз',
}

/** Backend details.errorCode → frontend AUTH_ERROR_CODES */
export const BACKEND_ERROR_CODE_MAP = {
  OTP_RESEND_COOLDOWN: AUTH_ERROR_CODES.RESEND_COOLDOWN,
  OTP_RATE_LIMIT_HOUR: AUTH_ERROR_CODES.RATE_LIMIT,
  OTP_TOO_MANY_ATTEMPTS: AUTH_ERROR_CODES.RATE_LIMIT,
  OTP_INVALID: AUTH_ERROR_CODES.INVALID_CODE,
  INVALID_OTP_FORMAT: AUTH_ERROR_CODES.INVALID_CODE,
  OTP_EXPIRED: AUTH_ERROR_CODES.EXPIRED_CODE,
  OTP_NOT_FOUND: AUTH_ERROR_CODES.EXPIRED_CODE,
  OTP_ALREADY_USED: AUTH_ERROR_CODES.CODE_USED,
  INVALID_UA_PHONE: AUTH_ERROR_CODES.INVALID_PHONE,
  REQUIRED_PHONE: AUTH_ERROR_CODES.INVALID_PHONE,
  TOKEN_INVALID: AUTH_ERROR_CODES.EXPIRED_CODE,
  TOKEN_EXPIRED: AUTH_ERROR_CODES.EXPIRED_CODE,
  TOKEN_USED: AUTH_ERROR_CODES.TOKEN_USED,
  INVALID_FIRST_NAME: AUTH_ERROR_CODES.INVALID_NAME,
  INVALID_LAST_NAME: AUTH_ERROR_CODES.INVALID_LAST_NAME,
  INVALID_EMAIL: AUTH_ERROR_CODES.INVALID_EMAIL,
  ACCOUNT_DISABLED: AUTH_ERROR_CODES.ACCOUNT_DISABLED,
  PHONE_CONFLICT: AUTH_ERROR_CODES.UNKNOWN,
}
